// extracted by mini-css-extract-plugin
export default {"Container":"TelephoneDirectory_Container__Hw-YM","BodyDiv":"TelephoneDirectory_BodyDiv__H-tSy"};